<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <form id="FormAccion" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="form-group form-row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <!-- <label for="Nombre">Nombre</label>
									<input type="text" v-model="objAccion.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
									<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/> -->
                                    <template v-if="!MostrarElementos">
                                        <div class="row g-3">
                                            <div v-for="(item, index) in ListaPaquetes" :key="index"
                                                class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 mb-1 d-flex flex-column text-center align-items-center justify-content-between">
                                                <figure class="figure position-relative">
                                                    <label :for="'radio_' + index" class="m-0">
                                                        <span v-if="!item.Imagen">
                                                            <img src="@/assets/style/image/sin_imagen_200.jpg"
                                                                class="figure-img img-fluid mx-auto  rounded" alt="...">
                                                        </span>

                                                        <span v-else>
                                                            <img :src="RutaFile + item.UrlImagen + item.Imagen"
                                                                class="figure-img img-fluid rounded" alt="..."
                                                                style="width: 200px; height: 200px; object-fit: cover;">
                                                        </span>
                                                    </label>

                                                    <figcaption class="figure-caption text-center">
                                                        {{ $formatNumber(item.Precio, '$') }} <br>
                                                        {{ $limitCharacters(item.Descripcion, 110) }}
                                                    </figcaption>

                                                    <div class="form-check galeria-check-03">
                                                        <input type="radio" name="radioselect" v-model="item.Selected"
                                                            @change="CheckPaquetes(item)" :value="true"
                                                            :id="'radio_' + index" class="form-check-input">
                                                    </div>
                                                </figure>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="row g-3">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <table class="table mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                class="text-green-black text-xxs font-weight-bolder opacity-7">
                                                                #</th>
                                                            <th
                                                                class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">
                                                                Imagen</th>
                                                            <th
                                                                class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">
                                                                Descripción</th>
                                                            <th width="25%"
                                                                class="text-uppercase text-green-black text-xxs font-weight-bolder opacity-7">
                                                                Precio y cantidad</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in ListaElementosPaq" :key="index">
                                                            <td class="align-middle text-center" style="width: 10px;">
                                                                <h6 class="mb-0 text-sm text-capitalize ps-3">
                                                                    {{ (index + 1) }}</h6>
                                                            </td>
                                                            <td class="align-middle text-center" style="width: 120px;">
                                                                <span v-if="item.IdCotizacionEventoPaqueteDetalle && item.Anexado != 1">
																	<span v-if="!item.Imagen">
																		<img src="@/assets/style/image/sin_imagen_180.jpg" class="img-fluid rounded">
																	</span>

																	<span v-else>
																		<img :src="RutaFile + item.UrlImagen + item.Imagen" class="img-fluid rounded">
																	</span>
																</span>

																<span v-else>
																	<span v-if="!item.Imagen">
                                                                    <img src="@/assets/style/image/sin_imagen_180.jpg"
                                                                            class="img-fluid rounded">
                                                                    </span>

                                                                    <span v-else>
                                                                        <img :src="RutaFile + item.UrlImagen + item.Imagen"
                                                                            class="img-fluid rounded">
                                                                    </span>
																</span>
                                                                
                                                            </td>
                                                            <td class="align-middle ps-3">

                                                                <div class="btn-group mb-0" role="group"
                                                                    aria-label="basic">
                                                                    <button type="button"
                                                                        @click="GetEstiloCampo(item, 'ESP');"
                                                                        :class="{ 'btn btn-sm btn-outline-primary mb-0': item.EstiloEsp, 'btn btn-sm btn-primary btn-nav-group mb-0': !item.EstiloEsp }">
                                                                        <i class="far fa-language"></i> Español
                                                                    </button>

                                                                    <button type="button"
                                                                        @click="GetEstiloCampo(item, 'ING');"
                                                                        :class="{ 'btn btn-sm btn-outline-primary mb-0': item.EstiloIng, 'btn btn-sm btn-primary btn-nav-group mb-0': !item.EstiloIng }">
                                                                        <i class="far fa-language"></i> Inglés
                                                                    </button>
                                                                </div>

                                                                <textarea v-show="item.EstiloEsp" readonly
                                                                    :value="item.Descripcion" class="form-control mt-1"
                                                                    rows="2"></textarea>
                                                                <textarea v-show="item.EstiloIng"
                                                                    :value="item.DescripcionIng" readonly
                                                                    class="form-control mt-1" rows="2"></textarea>
                                                            </td>

                                                            <td class="align-middle">
                                                                <div class="form-group row">
                                                                    <div class="col-5">
                                                                        <label :for="'cant_'+index">Cantidad</label>
                                                                    </div>
                                                                    <div class="col-7">
                                                                        <input :id="'cant_'+index" type="text" :value="item.Cantidad" readonly
                                                                            class="form-control form-control-sm">
                                                                    </div>
                                                                </div>
                                                                <div class="form-group row">
                                                                    <div class="col-5">
                                                                        <label :for="'prec_'+index">Precio</label>
                                                                    </div>
                                                                    <div class="col-7">
                                                                        <input :id="'prec_'+index" type="text" :value="$formatNumber(item.Precio,'$')" readonly
                                                                            class="form-control form-control-sm">
                                                                    </div>
                                                                </div>
                                                                <div class="form-group row">
                                                                    <div class="col-5">
                                                                        <label :for="'precT_'+index">Precio total</label>
                                                                    </div>
                                                                    <div class="col-7">
                                                                        <input :id="'precT_'+index" type="text" :value="$formatNumber(item.PrecioTotal,'$')" readonly
                                                                            class="form-control form-control-sm">
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <!-- <td class="align-middle">
                                                                <input type="text" :value="item.Precio" readonly
                                                                    class="form-control form-control-sm">
                                                            </td>

                                                            <td class="align-middle">
                                                                <input type="text" :value="$formatNumber(item.PrecioTotal,'$')" readonly
                                                                    class="form-control form-control-sm">
                                                            </td> -->
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                </div>
            </form>
        </template>
    </CLoader>
</template>

<script>

export default {
    name: 'FormAccion',
    props: ['poBtnSave'],
    components: {
    },
    data() {
        return {
            ConfigLoad: {
                ShowLoader: true,
                ClassLoad: false,
            },
            // objetos base
            objCotEvenPaquete: {
                IdCotizacionEventoPaquete: 0,
                Nombre: '',
                Precio: 0,
                Cantidad: 0,
                Descripcion: '',
                DescripcionIng: '',
                UrlImagen: '',
                Imagen: '',
                IdAgente: 0,
                IdCotizacionEvento: 0,
                IdPaquete: 0
            },
            objElemPaquete: {
                IdCotizacionEventoPaqueteDetalle: 0,
                Nombre: '',
                Precio: 0,
                PrecioTotal: 0,
                Cantidad: 0,
                UrlImagen: '',
                Imagen: '', 
                Descripcion: '',
                DescripcionIng: '',
                Anexado: 0,
                Notas: '',
                FYMP: '',
                IdElementoPaq: 0,
                IdCotizacionEventoPaquete: 0
            },
            RutaFile: '',
            MostrarElementos: false,
            ListaPaquetesSelect: [], // Paquetes seleccionados
            ListaElementosPaq: [], // Elementos del paquete seleccionado
            ListaPaquetes: [], // Paquetes existentes
            ListaElementos: [],
            errorvalidacion: [],
            Emit: this.poBtnSave.EmitSeccion,
        }
    },
    methods:
    {
        async SeleccionarPaquete() {
            this.errorvalidacion = [];
            this.poBtnSave.Toast = 0;
            this.poBtnSave.DisableBtn = true;
            this.bus.$emit('EnviarPaquete', this.ListaPaquetesSelect);
        },
        EjecutaConExito(res) {
            this.poBtnSave.DisableBtn = false;
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_' + this.Emit);
            this.bus.$emit('List_' + this.Emit);
        },
        EjecutaConError(err) {
            this.poBtnSave.DisableBtn = false;

            if (err.response.data.errors) {
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else {
                this.$toast.error(err.response.data.message);
            }
        },
        GetPaquetes() {
            return this.$http.get("paqueteshotelcotizacion/" + this.IdCotizacion
            ).then((res) => {
                this.ListaPaquetes = res.data.data.map(paq => {
                    let nuevoCotEvPaq = {
                        ...this.objCotEvenPaquete,
                        Selected:false,
                        ListaElementos: []
                    }
                    Object.assign(nuevoCotEvPaq, paq);

                    nuevoCotEvPaq.ListaElementos = res.data.elementos.filter(elem => paq.IdPaquete == elem.IdPaquete).map(elem => {
                        let newElem =  {
                            ...this.objElemPaquete,
                            EstiloIng: false,
                            EstiloEsp: true,
                        }
                        Object.assign(newElem, elem);

                        return newElem;
                    });

                    return nuevoCotEvPaq;
                });
                this.RutaFile = res.data.RutaFile;
            }).finally(() => {
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar() {
            this.ListaPaquetesSelect = [];
            this.errorvalidacion = [];
        },
        CheckPaquetes(item) {
            // COMENTAR EESTA LINEA EN CASO DE QUE EL INPUT SEA DE TIPO CHECKBOX
            if (item) this.ListaPaquetes.forEach(elem => elem.Selected = item.IdPaquete == elem.IdPaquete);
            
            this.ListaPaquetesSelect = this.ListaPaquetes.filter(elem => elem.Selected);
     
            this.FiltrarElementos();
        },
        FiltrarElementos() {
            this.ListaElementosPaq = [];
            this.ListaPaquetesSelect.forEach(elem => {
                if (elem.Selected) this.ListaElementosPaq = this.ListaElementosPaq.concat(elem.ListaElementos);
            })
        },
        ToggleVistaElementos() {
            if (this.ListaPaquetesSelect.length == 0) {
                this.$toast.info('Debe seleccionar un paquete primero');
                return
            }
            this.bus.$emit('HabilitarBtbVerElems', this.MostrarElementos);
            this.MostrarElementos = !this.MostrarElementos;
        },
        GetEstiloCampo(item, idioma) {
            item.EstiloEsp = idioma === 'ESP';
            item.EstiloIng = idioma === 'ING';
        }
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_' + this.Emit);
        this.bus.$on('Recovery_' + this.Emit, (objEvento) => {
            this.ConfigLoad.ShowLoader = true;
            this.poBtnSave.DisableBtn = false;

            // this.bus.$emit('HabilitarBtbVerElems', false);
            this.bus.$emit('HabilitarBtbVerElems', true);

            this.bus.$off('Save_' + this.Emit);
            this.bus.$on('Save_' + this.Emit, () => {
                this.SeleccionarPaquete();
            });
            this.Limpiar();

            if (objEvento.IdCotizacion != '') {
                this.IdCotizacion = objEvento.IdCotizacion;
                this.GetPaquetes().then(() => {
                    //SI RECIBIMOS PAQUETES ENTONCES COMBINAMOS EL PAQUETE DEL EVENTO CON EL PAQUETE HOTEL
                    objEvento.Paquetes.forEach(paq => {
                        let indexPaquete = this.ListaPaquetes.findIndex(elem => paq.IdPaquete == elem.IdPaquete);
                        if (indexPaquete >= 0) this.ListaPaquetes[indexPaquete] = structuredClone(paq);
                    })

                    // REFRESCAMOS EL ARRAY PARA MOSTRAR LOS CAMBIOS EN EL DOM
                    this.ListaPaquetes = structuredClone(this.ListaPaquetes)

                    // EJECUTAMOS CHECKPAQUETES PARA FORMAR EL ARREGLO DE PAQUETES SELECCIONADOS
                    this.CheckPaquetes();
                });
            } else {
                this.ConfigLoad.ShowLoader = false;
            }

            this.bus.$off('CambiarVistaPaq');
            this.bus.$on('CambiarVistaPaq', () => this.ToggleVistaElementos())

        });
    }
}
</script>
